module.exports = "<bdb-ml-modal #modal icon=\"error\" (buttonAlertClicked)=\"actionButtomModalBdb()\"\n    options-buttons='[{\"id\":\"0\",\"value\":\"Continuar\"}]'>\n</bdb-ml-modal>\n<bdb-ml-loader #loader></bdb-ml-loader>"


//////////////////
// WEBPACK FOOTER
// ./src/app/bdb-handler/bdb-handler.component.html
// module id = ./src/app/bdb-handler/bdb-handler.component.html
// module chunks = main